import { ILog } from "@ihr-radioedit/inferno-core";
import type { Store } from "../../../../client/stores";

const log = ILog.logger("Outbrain");

let hasRunOutbrain = false;
export const setupOutbrain = (store: Store) => {
  // Ensure outbrain is included once and only once
  if (hasRunOutbrain) {
    return;
  }
  const body = document.querySelector("body");

  if (body && store.site.config.sections?.partners?.outbrain_switch) {
    hasRunOutbrain = true;
    if (store.env.OUTBRAIN_WIDGET_URL) {
      const script = document.createElement("script");
      script.async = true;
      script.defer = true;
      script.src = store.env.OUTBRAIN_WIDGET_URL;
      script.onload = () => {
        log.debug("Outbrain loaded");
      };

      script.onerror = (
        event: Event | string,
        source?: string,
        fileno?: number,
        columnNumber?: number,
        error?: Error,
      ) => {
        if (error) {
          log.debug("Outbrain could not be loaded", error.message);
        }
      };
      body.appendChild(script);
    }

    if (store.env.OUTBRAIN_PIXEL_URL) {
      const img = document.createElement("img");
      img.src = store.env.OUTBRAIN_PIXEL_URL;
      img.alt = "outbrain pixel";
      img.style.display = "none";
      body.appendChild(img);
    }
  }
};
